import { useLazyQuery } from "@apollo/client";

import { MapEditorFeatureTypeQueryDocument } from "./queries.generated";

export function useMapEditorFeatureTypeQuery() {
    const [runQueryAsync] = useLazyQuery(MapEditorFeatureTypeQueryDocument);

    return async (mapEditorFeatureId: string) => {
        const response = await runQueryAsync({ variables: { mapEditorFeatureId } });
        return response.data?.mapEditorFeatureGetById.data.__typename;
    };
}
